module.exports = __webpack_public_path__ + "img/058.4c3815d3.svg";